import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilService {
    closestTagStartsWith(el: HTMLElement | null, tagPrefix: string) {
        let current: HTMLElement | null | undefined = el?.parentElement;
        while (current) {
            if (
                current.tagName &&
                current.tagName.toLowerCase().startsWith(tagPrefix.toLowerCase())
            ) {
                return current;
            }

            current = current.parentElement;
        }

        return null;
    }
}
